import { useTranslation } from 'react-i18next'
import type { OnboardingRecipientHistory } from '../../../api/onboardingTypes'
import RecipientNotice from './RecipientNotice'

/** Native text inputs cannot color substrings; list matching addresses immediately below instead. */
export default function RecipientHighlights({ histories, unavailable }: {
  histories: OnboardingRecipientHistory[]
  unavailable: boolean
}) {
  const { t } = useTranslation('pages')
  return <>
    <div className="flex flex-col gap-2" data-testid="onboarding-recipient-highlights">
      <RecipientNotice histories={histories} highlights />
    </div>
    {unavailable && <p role="alert" className="text-xs text-warning">{t('adminOnboarding.history.historyUnavailable')}</p>}
  </>
}
